/**
 * プッシュ通知登録
 */

import React from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Typography,
    Grid,
    InputBase,
    Button,
    FormHelperText,
    DialogTitle
} from '@material-ui/core';
import DeleteForever from '@material-ui/icons/DeleteForever';
import Toast from 'mdoc/utils/toast';
import { testColor } from 'mdoc/utils/index';
import ColorSelect from './ColorSelect';
import { dictionary, getUserInfo } from 'mdoc/admin/axios'
import appTemplate1 from 'mdoc/style/imgs/appTemplate1.gif'
import appTemplate2 from 'mdoc/style/imgs/appTemplate2.gif'
import appTemplate3 from 'mdoc/style/imgs/appTemplate3.gif'
import './Theam.less';
import * as config from 'mdoc/admin/axios/config';
import { getApp, delApp, saveApp, backImageUpload, backImageDown } from 'mdoc/admin/axios/design'
import Dialog from 'mdoc/utils/myDialog';
import $ from 'jquery';



const styles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    margin: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
    },
    bootstrapRoot: {
        space: {
            height: theme.spacing.unit
        },
    },
    bootstrapSelect: {
        backgroundColor: theme.palette.common.white,
        border: '1px solid #ced4da!important',
        paddingLeft: '5px'
    },
    error: {
        backgroundColor: 'red'
    },
    drop: {
        width: '298px'
    },
    buttonProgress: {
        color: 'ff0000',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
        opacity: 0.5
    },
    fileInput: {
        display: 'none',
    },
    bootstrapFormLabel: {
        lineHeight: '30px',
    },
    cusButton: {
        borderRadius: 0,
        boxShadow: 'none',
        backgroundColor: 'CED4DA',
        color: 'ffffff',
        maxWidth: '50%'
    },
    title:{
        marginLeft: '-20px',
        fontWeight:'bold'
    },
    fileTips: {
        color: 'rgba(0, 0, 0, 0.54)',
        paddingTop: '5px'
    }
});


class TheamApp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checkedA: true,
            dictWord: {
                registration: '',
                msg_info_add_completed: '',
                header_background_color: '',
                body_background_color: '',
                footer_background_color: '',
                reset: '',
                sample: '',
                personal_background_color: '',
                browsing_background_color: '',
                body_background_image: '',
                file_select: '',
                msg_error_character_not_correct: '',
                yes: '',
                cancel: '',
                confirmation: '',
                msg_reset_setting: '',
                upload_only_image_files: '',
            },
            headerBackColor: 'f7f7f7',
            bodyBackColor: 'FFF',
            footerBackColor: 'FFF',
            personalMenuBackColor: 'FFF',
            contentBackColor: 'FFF',
            bodyBackImage: null,
            clientId: getUserInfo().clientId,
            design: null,
            bodyBackImageSrc: null,
            headerBackColorVal: 'f7f7f7',
            bodyBackColorVal: 'FFF',
            footerBackColorVal: 'FFF',
            personalMenuBackColorVal: 'FFF',
            contentBackColorVal: 'FFF',
            dialogOpen: false,
            changeGrey:null,
            headerBackColorStyle: 0,
            bodyBackColorStyle: 0,
            footerBackColorStyle: 0,
            personalMenuBackColorStyle: 0,
            contentBackColorStyle: 0,
        }
    }

    UNSAFE_componentWillMount() {
        let dictWord = {}
        dictionary(this.state.dictWord).then(res => {
            for (let key in res) {
                let val = res[key];
                dictWord[val.dictKey] = val.dictValue;
            }
            this.setState({
                dictWord,
            })
        })
        this.load();
    }

    componentDidMount() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
    load() {
        let me = this;
        getApp(me.state.clientId)
            .then(res => {
                let design = null, bodyBackImage = null, designVal = {
                    headerBackColorVal: me.state.headerBackColor,
                    bodyBackColorVal: me.state.bodyBackColor,
                    footerBackColorVal: me.state.footerBackColor,
                    personalMenuBackColorVal: me.state.personalMenuBackColor,
                    contentBackColorVal: me.state.contentBackColor,
                };
                if (res.appDesignId) {
                    design = {
                        headerBackColor: res.headerBackColor.replace('#', ''),
                        bodyBackColor: res.bodyBackColor.replace('#', ''),
                        footerBackColor: res.footerBackColor.replace('#', ''),
                        personalMenuBackColor: res.personalMenuBackColor.replace('#', ''),
                        contentBackColor: res.contentBackColor.replace('#', ''),
                        appDesignId: res.appDesignId
                    }
                    bodyBackImage = res.bodyBackImage;

                    designVal = {
                        headerBackColorVal: res.headerBackColor.replace('#', ''),
                        bodyBackColorVal: res.bodyBackColor.replace('#', ''),
                        footerBackColorVal: res.footerBackColor.replace('#', ''),
                        personalMenuBackColorVal: res.personalMenuBackColor.replace('#', ''),
                        contentBackColorVal: res.contentBackColor.replace('#', ''),
                    };
                }
                me.setState({
                    design,
                    bodyBackImage,
                    bodyBackImageSrc: null,
                    ...designVal,
                    headerBackColorError: null,
                    bodyBackColorError: null,
                    footerBackColorError: null,
                    personalMenuBackColorError: null,
                    contentBackColorError: null,
                }, () => {
                    if (res && res.bodyBackImage) {
                        backImageDown(res && res.bodyBackImage).then(res => {
                            me.setState({
                                bodyBackImageSrc: res
                            })
                        });
                    }
                });
            }).catch(error => {
                Toast.info(error)
            })
    }

    fileButton(id) {
        let fileInput = document.getElementById(id);
        fileInput.value = '';
    }
    onBackImageDrop(event) {
        let me = this;
        let files = event.target.files || [];
        if (files.length < 1) return;
        let file = files[0];
        let name = file.name;
        let type = name.substr(name.lastIndexOf(".")).toLowerCase();//获得文件后缀名
        if (['.gif', '.png', '.jpg', '.jpeg'].indexOf(type) < 0) {
            Toast.error(me.state.dictWord['msg_error_upload_file_type_invalid']);
            return;
        }
        // if (file.size > config.FILE_MAX_SIZE) {
        //     Toast.error(me.state.dictWord['msg_error_file_size_over_length']);
        //     return false;
        // }
        let data = new FormData();
        data.append("upfile", file);
        backImageUpload(data)
            .then(res => {
                me.setState({
                    bodyBackImage: res.fileUuid,
                }, () => {
                    backImageDown(res.fileUuid).then(res => {
                        me.setState({
                            bodyBackImageSrc: res,
                        })
                    });
                });
            }).catch(error => {
                Toast.info(error)
            })

    }
    updateColor(key, color) {
        // color = color.replace('#', '');
        // let changeGrey=this.state.changeGrey;
        // let design = changeGrey;
        // if (design === null) {
        //     design = {};
        // }
        // design[key] = color;
        // let state = this.state;
        // state[key + 'Val'] = color;
        // state[key + 'Error'] = null;
        // this.setState({
        //     ...state,
        //     design,
        // });

        color = color.replace('#', '');
        // let changeGrey=this.state.changeGrey;
        // let design = changeGrey;
        let design = this.state.design;
        // let changeGrey = this.state.changeGrey?this.state.changeGrey:design;
        // changeGrey = Object.assign({},changeGrey);
        // changeGrey[key]=color;
        if (!design) {
            design = {};
        }
        design[key] = color;
        // for(let i in design){
        //     if(i===key){
        //         design[key] = color;
        //     }else{
        //         design[i] = 'cccccc59';
        //     }
        // }
        let state = this.state;
        state[key + 'Val'] = color;
        state[key + 'Error'] = null;
        this.setState({
            ...state,
            design,
        })
    }
    closeColorSelect(key, color){
        color = color.replace('#', '');
        let state = this.state;
        let me=this;
        // let changeGrey=state.changeGrey;
        if (testColor(color)) {
            let design = state.design;
            if (!design) {
                design = {};
            }
            design[key] = color;
            state[key + 'Val'] = color;
            state[key + 'Error'] = null;
            me.setState({
                ...state,
                design,
            })
        } else {
            state[key + 'Error'] = state.dictWord.msg_error_character_not_correct;
            me.setState({
                ...state
            })
        }
        this.onCancelBorder();
    }
    handleColorChange(key, event) {
        let state = this.state;
        let design = this.state.design;
        // for(let i in design){
        //     if(i===key){
        //         design[key] = event.target.value;
        //         state[key + 'Val'] = event.target.value;
        //     }else{
        //         design[i] = 'cccccc59';
        //     }
        // }
        design[key] = event.target.value;
        state[key + 'Val'] = event.target.value;
        state[key + 'Error'] = null;
        this.setState({
            ...state
        })
        this.onAddBorder(key);
    }
    handleColorBlur(key, event) {
        let state = this.state;
        // let changeGrey=state.changeGrey;
        if (testColor(event.target.value)) {
            let design = state.design;
            if (!design) {
                design = {};
            }
            design[key] = event.target.value;
            state[key + 'Val'] = event.target.value;
            state[key + 'Error'] = null;
            this.setState({
                ...state,
                design,
            })
        } else {
            state[key + 'Error'] = state.dictWord.msg_error_character_not_correct;
            this.setState({
                ...state
            })
        }
        this.onCancelBorder();
    }

    colorOnFocus(key,event){

        let state = this.state;
        let design = this.state.design;
        // let changeGrey = this.state.changeGrey?this.state.changeGrey:design;
        // changeGrey = Object.assign({},changeGrey);
        // changeGrey[key]=event.target.value;
        // for(let i in design){
        //     if(i===key){
        //         design[key] = event.target.value;
        //     }else{
        //         design[i] = 'cccccc59';
        //     }
        // }
        if (!design) {
            design = {};
        }
        design[key] = event.target.value;
        state[key + 'Val'] = event.target.value;
        state[key + 'Error'] = null;
        this.setState({
            ...state,
            design,
            // changeGrey
        })
        this.onAddBorder(key);
    }

    onSelectClick(color){
        let state=this.state;
        let design=state.design;
        // let changeGrey = this.state.changeGrey?this.state.changeGrey:design;
        // changeGrey = Object.assign({},changeGrey);
        // changeGrey[color]=design[color];
        // for(let i in design){
        //     if(i===color){
        //         design[color] =design[i];
        //         state[color + 'Val'] = design[i];
        //     }else{
        //         design[i] = 'cccccc59';
        //     }
        // }
        if (!design) {
            design = {};
        }
        state[color + 'Val'] = design[color];
        state[color + 'Error'] = null;
        this.setState({
            ...state,
            design,
            // changeGrey
        })
        this.onAddBorder(color);
    }

    onAddBorder(key){
        $(".template div").each(function(e){
            if($(this).attr('value') === key){
                $(this).css({
                    'border':"4px dashed red",
                    'z-index':"0",
                });
                // if(key === 'contentBackColor'){
                //     $(this).css({
                //         'z-index':"10",
                //         'opacity': '0.9',
                //     });
                // }
            }else{
                $(this).css({
                    'z-index':"9",
                    'border': '0px',
                    'opacity': '0.8',
                });
            }
        });
    }

    onCancelBorder(){
        $(".template div").each(function(e){
            $(this).css({
                'z-index':"0",
                'border': '0px',
                'opacity': '1',
            });
        });
    }

    handleSave() {
        let me = this;
        if (me.state.headerBackColorError ||
            me.state.bodyBackColorError ||
            me.state.footerBackColorError ||
            me.state.personalMenuBackColorError ||
            me.state.contentBackColorError) {
            return false;
        }
        let data = {
            clientId: me.state.clientId,
            headerBackColor: me.state.headerBackColor,
            bodyBackColor: me.state.bodyBackColor,
            footerBackColor: me.state.footerBackColor,
            personalMenuBackColor: me.state.personalMenuBackColor,
            contentBackColor: me.state.contentBackColor,
            bodyBackImage: me.state.bodyBackImage,
            ...me.state.design
        };
        for (let key in data) {
            if (['headerBackColor', 'bodyBackColor', 'footerBackColor', 'personalMenuBackColor', 'contentBackColor'].indexOf(key) >= 0) {
                data[key] = '#' + data[key];
            }
        }
        saveApp(data)
            .then(res => {
                Toast.success(me.state.dictWord['msg_info_add_completed']);
                me.load();
            }).catch(error => {
                Toast.info(error)
            })

    }
    reset() {
        let me = this;
        if (me.state.design !== undefined && me.state.design.appDesignId) {
            delApp(me.state.design.appDesignId)
                .then(res => {
                    me.load();
                }).catch(error => {
                    Toast.info(error)
                })
        } else {
            me.setState({
                bodyBackImage: null,
                bodyBackImageSrc: null,
                headerBackColorVal: me.state.headerBackColor,
                bodyBackColorVal: me.state.bodyBackColor,
                footerBackColorVal: me.state.footerBackColor,
                personalMenuBackColorVal: me.state.personalMenuBackColor,
                contentBackColorVal: me.state.contentBackColor,

                headerBackColorError: null,
                bodyBackColorError: null,
                footerBackColorError: null,
                personalMenuBackColorError: null,
                contentBackColorError: null,
            }, () => {
                me.load();
            });
        }
    }
    dialogHandleOK() {
        this.setState({ dialogOpen: false }, () => {
            this.reset();
        })
    }
    render() {
        const { classes } = this.props;
        return (
            <div className="mainDom" style={{ minWidth: '700px' }}>
                <div className={classes.appBarSpacer} />
                <Grid
                    container
                    direction="row"
                    justify="flex-start"
                    alignItems="flex-start"
                >
                    <Grid item xs={8} sm={4}>
                        <Grid container className={classes.margin} >
                            <label className="form-label"> {this.state.dictWord.header_background_color}</label>
                            <InputBase type="text" style={{ width: "40%", height: "27px" }} id="headerBackColor" value={this.state.headerBackColorVal} classes={{ root: classes.bootstrapRoot, input: classes.bootstrapSelect }} onChange={this.handleColorChange.bind(this, 'headerBackColor')} onBlur={this.handleColorBlur.bind(this, 'headerBackColor')} onFocus={this.colorOnFocus.bind(this,'headerBackColor')} />
                            <ColorSelect
                                style={{ verticalAlign: "middle" }}
                                color={'#' + this.state.headerBackColorVal}
                                objKey="headerBackColor"
                                closeColorSelect={this.closeColorSelect.bind(this)}
                                onChange={this.updateColor.bind(this)}
                                onClick={this.onSelectClick.bind(this,'headerBackColor')}
                            />
                        </Grid>
                        {this.state.headerBackColorError ? <FormHelperText style={{ color: '#f00' }}>{this.state.headerBackColorError}</FormHelperText> : null}

                        <Grid container className={classes.margin} >
                            <label className="form-label"> {this.state.dictWord.body_background_color}</label>
                            <InputBase type="text" style={{ width: "40%", height: "27px" }} value={this.state.bodyBackColorVal} classes={{ root: classes.bootstrapRoot, input: classes.bootstrapSelect }} onChange={this.handleColorChange.bind(this, 'bodyBackColor')} onBlur={this.handleColorBlur.bind(this, 'bodyBackColor')} onFocus={this.colorOnFocus.bind(this,'bodyBackColor')} />
                            <ColorSelect
                                style={{ verticalAlign: "middle" }}
                                color={'#' + this.state.bodyBackColorVal}
                                objKey="bodyBackColor"
                                closeColorSelect={this.closeColorSelect.bind(this)}
                                onChange={this.updateColor.bind(this)}
                                onClick={this.onSelectClick.bind(this,'bodyBackColor')}
                            />
                        </Grid>
                        {this.state.bodyBackColorError ? <FormHelperText style={{ color: '#f00' }}>{this.state.bodyBackColorError}</FormHelperText> : null}


                        <Grid container className={classes.margin}>
                            <label className="form-label">{this.state.dictWord.body_background_image}</label>
                            <input
                                accept=".gif,.png,.jpg,.jpeg"
                                className={classes.fileInput}
                                id="backimage-file"
                                type="file"
                                onChange={this.onBackImageDrop.bind(this)}
                            />
                            <label htmlFor="backimage-file">
                                <InputBase style={{ width: "170px", height: "27px" }} readOnly classes={{ root: classes.bootstrapRoot, input: classes.bootstrapSelect }} />
                                <Button variant="contained" component="span" className={classes.cusButton} style={{ height: '29px', width: '110px',backgroundColor:'#2196f3',color:'white'}} onClick={this.fileButton.bind(this, 'backimage-file')} >
                                    {this.state.dictWord.file_select}
                                </Button>
                            </label>
                            <div className={classes.fileTips}>
                                {this.state.dictWord.upload_only_image_files}
                            </div>
                        </Grid>
                        {this.state.bodyBackImageSrc ? <Grid container className={classes.margin} style={{ display: 'flex' }}>
                            <p style={{ flex: '3', width: '80%', height: '345px' }}><img src={this.state.bodyBackImageSrc} alt="" style={{ width: '100%', height: '100%' }} /></p>
                            <p style={{ flex: '1' }}><Button color="primary" onClick={() => { this.setState({ bodyBackImageSrc: null, bodyBackImage: null }) }}><DeleteForever /></Button></p>
                        </Grid> : null}

                        <Grid container className={classes.margin} >
                            <label className="form-label"> {this.state.dictWord.footer_background_color}</label>
                            <InputBase type="text" style={{ width: "40%", height: "27px" }} value={this.state.footerBackColorVal} classes={{ root: classes.bootstrapRoot, input: classes.bootstrapSelect }} onChange={this.handleColorChange.bind(this, 'footerBackColor')} onBlur={this.handleColorBlur.bind(this, 'footerBackColor')} onFocus={this.colorOnFocus.bind(this,'footerBackColor')} />
                            <ColorSelect
                                style={{ verticalAlign: "middle" }}
                                color={'#' + this.state.footerBackColorVal}
                                objKey="footerBackColor"
                                closeColorSelect={this.closeColorSelect.bind(this)}
                                onChange={this.updateColor.bind(this)}
                                onClick={this.onSelectClick.bind(this,'footerBackColor')}
                            />
                        </Grid>
                        {this.state.footerBackColorError ? <FormHelperText style={{ color: '#f00' }}>{this.state.footerBackColorError}</FormHelperText> : null}

                        <Grid container className={classes.margin} >
                            <label className="form-label"> {this.state.dictWord.personal_background_color}</label>
                            <InputBase type="text" style={{ width: "40%", height: "27px" }} value={this.state.personalMenuBackColorVal} classes={{ root: classes.bootstrapRoot, input: classes.bootstrapSelect }} onChange={this.handleColorChange.bind(this, 'personalMenuBackColor')} onBlur={this.handleColorBlur.bind(this, 'personalMenuBackColor')} onFocus={this.colorOnFocus.bind(this,'personalMenuBackColor')} />
                            <ColorSelect
                                style={{ verticalAlign: "middle" }}
                                color={'#' + this.state.personalMenuBackColorVal}
                                objKey="personalMenuBackColor"
                                closeColorSelect={this.closeColorSelect.bind(this)}
                                onChange={this.updateColor.bind(this)}
                                onClick={this.onSelectClick.bind(this,'personalMenuBackColor')}
                            />
                        </Grid>
                        {this.state.personalMenuBackColorError ? <FormHelperText style={{ color: '#f00' }}>{this.state.personalMenuBackColorError}</FormHelperText> : null}

                        <Grid container className={classes.margin} >
                            <label className="form-label">{this.state.dictWord.browsing_background_color}</label>
                            <InputBase type="text" style={{ width: "40%", height: "27px" }} value={this.state.contentBackColorVal} classes={{ root: classes.bootstrapRoot, input: classes.bootstrapSelect }} onChange={this.handleColorChange.bind(this, 'contentBackColor')} onBlur={this.handleColorBlur.bind(this, 'contentBackColor')} onFocus={this.colorOnFocus.bind(this,'contentBackColor')} />
                            <ColorSelect
                                style={{ verticalAlign: "middle" }}
                                color={'#' + this.state.contentBackColorVal}
                                objKey="contentBackColor"
                                closeColorSelect={this.closeColorSelect.bind(this)}
                                onChange={this.updateColor.bind(this)}
                                onClick={this.onSelectClick.bind(this,'contentBackColor')}
                            />
                        </Grid>
                        {this.state.contentBackColorError ? <FormHelperText style={{ color: '#f00' }}>{this.state.contentBackColorError}</FormHelperText> : null}

                        <Grid container className={classes.margin}>
                            <Button variant="contained" color="primary" onClick={this.handleSave.bind(this)}>
                                {this.state.dictWord.registration}
                            </Button>
                            <Button variant="contained" color="primary" onClick={() => { this.setState({ dialogOpen: true }) }} disabled={this.state.design ? false : true} style={{ marginLeft: '10px' }}>
                                {this.state.dictWord.reset}
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <Typography variant="subtitle1" gutterBottom style={{ textAlign: 'center', color: '636363' }}>
                            {this.state.dictWord.sample}
                        </Typography>
                        <div className="app-template">
                            <div className="template appTemplate1">
                                <img src={appTemplate1} className="img" alt="" />
                                <div className="headerBg" value="headerBackColor" style={{ background: this.state.design && this.state.design.headerBackColor ? '#' + this.state.design.headerBackColor : '#' + this.state.headerBackColor }} />
                                <div className="bodyBg" value="bodyBackColor" style={this.state.bodyBackImageSrc ? {
                                    backgroundColor: this.state.design && this.state.design.bodyBackColor ? '#' + this.state.design.bodyBackColor : '#' + this.state.bodyBackColor,
                                    backgroundImage: "URL('" + this.state.bodyBackImageSrc + "')",
                                    backgroundSize: '100% 100%'
                                } : {
                                        backgroundColor: this.state.design && this.state.design.bodyBackColor ? '#' + this.state.design.bodyBackColor : '#' + this.state.bodyBackColor
                                    }}
                                />
                                <div className="footerBg" value="footerBackColor" style={{ background: this.state.design && this.state.design.footerBackColor ? '#' + this.state.design.footerBackColor : '#' + this.state.footerBackColor }} />
                            </div>
                            <div className="template appTemplate2">
                                <img src={appTemplate2} alt="" className="img" />
                                <div className="headerBg" value="headerBackColor" style={{ background: this.state.design && this.state.design.headerBackColor ? '#' + this.state.design.headerBackColor : '#' + this.state.headerBackColor }} />
                                <div className="personalMenuBg" value="personalMenuBackColor" style={{ background: this.state.design && this.state.design.personalMenuBackColor ? '#' + this.state.design.personalMenuBackColor : '#' + this.state.personalMenuBackColor }} />
                            </div>
                            <div className="template appTemplate3">
                            <img src={appTemplate3} alt="" className="img" />
                                <div className="headerBg" value="headerBackColor" style={{ background: this.state.design && this.state.design.headerBackColor ? '#' + this.state.design.headerBackColor : '#' + this.state.headerBackColor,height:'65px' }} />
                                <div className="contentBg" value="contentBackColor" style={{ background: this.state.design && this.state.design.contentBackColor ? '#' + this.state.design.contentBackColor : '#' + this.state.contentBackColor }} />
                                
                                <div className="footerBg" value="footerBackColor" style={{ background: this.state.design && this.state.design.footerBackColor ? '#' + this.state.design.footerBackColor : '#' + this.state.footerBackColor }} />
                            </div>
                        </div>
                    </Grid>
                </Grid>
                <Dialog
                    open={this.state.dialogOpen}
                    option={{
                        ok: {
                            text: this.state.dictWord['yes'],
                        },
                        close: {
                            text: this.state.dictWord['cancel'],
                        },
                    }}
                    titleDoc={<DialogTitle disableTypography id="" className={classes.title}>{this.state.dictWord['confirmation']}</DialogTitle>}
                    content={
                        <p>{this.state.dictWord['msg_reset_setting']}</p>
                    }
                    handleOk={this.dialogHandleOK.bind(this)}
                    handleClose={() => { this.setState({ dialogOpen: false }) }}
                />
            </div >
        )
    }
}

TheamApp.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TheamApp);